import React, { useState } from 'react';
import axios from 'axios';

const AddMedicineFromExcel = () => {
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState('');

  // Handle file selection
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  // Handle form submission
  const handleFileUpload = async () => {
    if (!file) {
      setStatus('Please select a file');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      setStatus('Uploading...');
      const response = await axios.post('https://api.swasthmitra.com/api/medicine/upload-excel', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setStatus(response.data.message); // Success message from backend
      setFile(null); // Clear file state
      document.getElementById('file-input').value = ''; // Clear file input
    } catch (err) {
      setStatus('Error uploading file');
      console.error(err);
    }
  };

  return (
    <div style={{ maxWidth: '400px', margin: '0 auto', textAlign: 'center' }}>
      <h2>Upload Medicines from Excel</h2>
      <input
        id="file-input"
        type="file"
        accept=".xlsx"
        onChange={handleFileChange}
        style={{ marginBottom: '10px' }}
      />
      <button onClick={handleFileUpload} style={{ padding: '10px 20px', cursor: 'pointer' }}>
        Upload
      </button>
      {status && (
        <p style={{ marginTop: '10px', color: status.includes('Error') ? 'red' : 'green' }}>
          {status}
        </p>
      )}
    </div>
  );
};

export default AddMedicineFromExcel;
